"use client";
import { PhaseState } from "@/app/(components)/Basic/PhaseBar/constants";
import { metamaskErrorToast } from "@/shared/errors";
import { useCallback, useState } from "react";
import { ProgressContext } from "./context";
import { PhaseStateType } from "./types";

export interface Props {
  children: React.ReactNode;
}

export const ProgressContextProvider = ({ children }: Props) => {
  const [clearForm, setClearForm] = useState<() => void>();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const [onClose, setOnClose] = useState<() => void>();

  const [phaseState, setPhaseState] = useState<PhaseStateType>({});

  const [error, setError] = useState();

  const closeModal = useCallback(() => {
    onClose?.();
    setIsOpen(false);
  }, [onClose]);

  const handleClose = useCallback(() => {
    closeModal();

    setError(undefined);
    setPhaseState({});
  }, [closeModal]);

  const handleError = useCallback(
    async (phase: number, error: any) => {
      setPhaseState((state) => ({ ...state, [phase]: PhaseState.ERROR }));

      metamaskErrorToast(error);

      closeModal();
    },
    [closeModal],
  );

  return (
    <ProgressContext.Provider
      value={{
        isOpen,
        setIsOpen,
        phaseState,
        setPhaseState,
        error,
        setError,
        handleError,
        setOnClose,
        onClose: handleClose,
        clearForm,
        setClearForm,
      }}
    >
      {children}
    </ProgressContext.Provider>
  );
};
